var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MultiStepDialog',{attrs:{"max-width":"400px","content-class":"connected-dialog","steps":_vm.steps},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(index,name){return {key:name,fn:function(data){return [_vm._t(name,null,null,data)]}}})],null,true),model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}})
}
var staticRenderFns = []

export { render, staticRenderFns }